module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0, false, false)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scale-tool"
  }, [_c('img', {
    attrs: {
      "src": require("./scale-v2.svg")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-427c55fb!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fragment/scale-tool/index.vue
// module id = 233
// module chunks = 0